import { Gift, Check } from "lucide-react";
import { useConfig, money } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { useCart } from "@/lib/cart";
import { useSeason } from "@/lib/holiday";

export const GiftWrapBox = () => {
  const { t } = useI18n();
  const { data } = useConfig();
  const { active } = useSeason();
  const { wrap, setWrap } = useCart();
  const product = data?.gift_wrap;
  if (!active && !product) return null;
  return (
    <div data-testid="gift-wrap-box" className="border border-[#c9a55c]/30 bg-[#0b0a08] p-4 space-y-3">
      <p className="flex items-center gap-2 text-sm font-semibold"><Gift size={15} className="text-gold" /> {t("wrap_title")}</p>
      {product && (
        <button type="button" data-testid="gift-wrap-toggle" onClick={() => setWrap({ ...wrap, on: !wrap.on })} className="w-full flex items-center gap-3 text-left">
          <span className={`h-5 w-5 border flex items-center justify-center shrink-0 transition-colors ${wrap.on ? "bg-gold border-transparent text-[#0b0a08]" : "border-white/30"}`}>{wrap.on && <Check size={12} />}</span>
          <span className="flex-1 text-sm">{t("wrap_option")}</span>
          <span data-testid="gift-wrap-price" className="text-sm text-gold">{t("wrap_price", { amount: money(product.price) })}</span>
        </button>
      )}
      {active && (
        <div>
          <p className="text-xs text-white/60 mb-1.5">{t("wrap_card")}</p>
          <textarea data-testid="gift-card-message-input" value={wrap.message} maxLength={300} rows={2} onChange={(e) => setWrap({ ...wrap, message: e.target.value })}
            placeholder={t("wrap_card_placeholder")} className="w-full bg-transparent border border-white/15 px-3 py-2 text-sm resize-none focus:outline-none focus:border-[#c9a55c]" />
          <p className="text-[10px] text-white/35 mt-1">{wrap.message.length}/300 · {t("wrap_note")}</p>
        </div>
      )}
    </div>
  );
};
